.playButton {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;

    path {
        fill: rgba(255, 255, 255, 0.8);
    }
}
